import React from 'react';
import { Chip } from '@mui/material';

type StatusPillProps = {
  value: boolean | string;
  trueLabel?: string;
  falseLabel?: string;
  valueMap?: Record<string, { label: string; color?: 'success' | 'warning' | 'error' | 'default' }>;
};

const StatusPill: React.FC<StatusPillProps> = ({
  value,
  trueLabel = 'Activo',
  falseLabel = 'Inactivo',
  valueMap = {},
}) => {
  const whiteLabelSx = { fontWeight: 500, '& .MuiChip-label': { color: '#fff' } };
  const defaultSx = { fontWeight: 500 };
  if (typeof value === 'boolean') {
    return (
      <Chip
        label={value ? trueLabel : falseLabel}
        size="small"
        color={value ? 'success' : 'default'}
        variant="filled"
        sx={value ? whiteLabelSx : defaultSx}
      />
    );
  }
  const mapped = valueMap[value];
  if (mapped) {
    const isColored = mapped.color && mapped.color !== 'default';
    return (
      <Chip
        label={mapped.label}
        size="small"
        color={mapped.color || 'default'}
        variant="filled"
        sx={isColored ? whiteLabelSx : defaultSx}
      />
    );
  }
  return <Chip label={String(value)} size="small" variant="outlined" sx={defaultSx} />;
};

export default StatusPill;
